import type {
  AdhocResult,
  AdhocTabId,
  AdhocTabRuntime,
  PersistedAdhocTab,
  WorkbenchState,
} from "../types";

export function getTab(
  state: WorkbenchState,
  tabId: AdhocTabId | null,
): PersistedAdhocTab | undefined {
  return tabId == null ? undefined : state.tabs.find((tab) => tab.id === tabId);
}

export function getActiveResult(
  runtime: AdhocTabRuntime | undefined,
): AdhocResult | undefined {
  if (!runtime?.activeResultId) {
    return undefined;
  }
  return runtime.results.find((result) => result.id === runtime.activeResultId);
}

/** Ids of the in-flight results belonging to one tab. */
export function getRunningResultIdsForTab(
  state: WorkbenchState,
  tabId: AdhocTabId,
): string[] {
  return (state.runtimeByTabId[tabId]?.results ?? [])
    .filter((result) => result.status === "running")
    .map((result) => result.id);
}
